import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsLMS';
import { normalizeValue } from '../../../../../utils/Texts';

export default function SemestresModal({ open, mode, data, onClose, onSubmit, inline }) {
    const [form, setForm] = useState({
        nombre: '',
        idCarrera: '',
        idSemestreAnterior: null,
        activo: true // Siempre true por defecto
    });
    const [carreras, setCarreras] = useState([]);
    const [semestres, setSemestres] = useState([]);

    useEffect(() => {
        const init = async () => {
            if (open) {
                await loadCatalogs();
                if (mode === 'edit' && data) {
                    setForm({
                        nombre: normalizeValue(data.nombre),
                        idCarrera: data.idCarrera || '',
                        idSemestreAnterior: data.idSemestreAnterior || null,
                        activo: data.activo ?? true
                    });
                } else {
                    setForm({
                        nombre: '',
                        idCarrera: '',
                        idSemestreAnterior: null,
                        activo: true
                    });
                }
            }
        };
        init();
    }, [mode, data, open]);

    const loadCatalogs = async () => {
        try {
            const [carrRes, semRes] = await Promise.all([
                axios.get(ENDPOINTS.carreras),
                axios.get(ENDPOINTS.semestres)
            ]);
            const carrierasNormalized = (carrRes.data || []).map(x => Models.carrera(x));
            const semestresNormalized = (semRes.data || []).map(x => Models.semestre(x));

            setCarreras(carrierasNormalized);
            setSemestres(semestresNormalized.filter(s => s.idSemestre !== (data?.idSemestre || 0)));
        } catch (error) {
            console.error('Error al cargar catálogos para semestres:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let val = type === 'checkbox' ? checked : value;

        if (name === 'idCarrera' || name === 'idSemestreAnterior') {
            val = value ? parseInt(value) : (name === 'idSemestreAnterior' ? null : '');
        }

        setForm(prev => {
            const updated = {
                ...prev,
                [name]: val
            };
            if (name === 'idCarrera') {
                updated.idSemestreAnterior = null;
            }
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Aseguramos que activo siempre vaya en true si es lo que se requiere por defecto
        onSubmit({ ...form, activo: true }, mode);
    };

    if (!open) return null;

    const Header = (
        <div className="roles-topbar" style={{ marginBottom: '0.6rem', paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nuevo Semestre' : 'Editar Semestre'}
            </h3>
            {!inline && (
                <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
            )}
        </div>
    );

    const Body = (
        <div style={{ paddingLeft: '5%', paddingRight: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', overflowY: 'auto' }}>
            <div style={{ gridColumn: 'span 2' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre del Semestre:</label>
                <br /><br />
                <input
                    className="infoField"
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    required
                    maxLength={100}
                    placeholder="Ej. Primer Semestre 2026"
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Carrera:</label>
                <br /><br />
                <select
                    className="infoField"
                    name="idCarrera"
                    value={form.idCarrera}
                    onChange={handleChange}
                    required
                >
                    <option value="">-- Seleccione Carrera --</option>
                    {carreras.map((c, idx) => (
                        <option key={c.idCarrera || idx} value={c.idCarrera}>
                            {normalizeValue(c.nombre)}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Semestre Anterior (Opcional):</label>
                <br /><br />
                <select
                    className="infoField"
                    name="idSemestreAnterior"
                    value={form.idSemestreAnterior || ''}
                    onChange={handleChange}
                >
                    <option value="">-- Ninguno --</option>
                    {semestres
                        .filter(s => form.idCarrera && Number(s.idCarrera) === Number(form.idCarrera))
                        .map((s, idx) => (
                        <option key={s.idSemestre || idx} value={s.idSemestre}>
                            {normalizeValue(s.nombre)}
                        </option>
                    ))}
                </select>
            </div>

            {/* Checkbox de activo removido a petición del usuario */}
        </div>
    );

    const Footer = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', marginTop: '.8rem', paddingRight: 16 }}>
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={handleSubmit}
                disabled={!form.nombre || !form.idCarrera}
                style={{ opacity: (!form.nombre || !form.idCarrera) ? 0.5 : 1, cursor: (!form.nombre || !form.idCarrera) ? 'not-allowed' : 'pointer' }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className={inline ? "roles-inline-card" : "roles-modal-overlay"}>
            <div className={inline ? "" : "roles-modal-content"} style={inline ? { display: 'flex', flexDirection: 'column', gap: 0 } : {}}>
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
